import PlatformLanguageSwitcher from './PlatformLanguageSwitcher';


export default PlatformLanguageSwitcher;
